import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '../../components/UI'
import { materialCalculatorApi } from '../../services/materialCalculator'

export default function MCRulesetsPage() {
  const navigate = useNavigate()
  const [rulesets, setRulesets] = useState([])

  useEffect(() => { materialCalculatorApi.listRulesets().then(setRulesets).catch(() => setRulesets([])) }, [])

  return (
    <Card>
      <CardHeader><CardTitle>Reglas y parámetros</CardTitle></CardHeader>
      <CardContent>
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50"><tr><th className="px-3 py-2 text-left">Conjunto de reglas</th><th className="px-3 py-2">Versión</th><th className="px-3 py-2">Estado</th><th className="px-3 py-2">Acción</th></tr></thead>
          <tbody>
            {rulesets.map((r) => (
              <tr key={r.id} className="border-t">
                <td className="px-3 py-2">{r.ruleKey}</td>
                <td className="px-3 py-2 text-center">{r.version}</td>
                <td className="px-3 py-2 text-center">{r.isActive ? 'Predeterminado' : 'Inactivo'}</td>
                <td className="px-3 py-2 text-center"><button className="text-primary-700 underline" onClick={() => navigate(`/material-calculator/rulesets/${r.id}`)}>Ver / editar ajustes</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  )
}
